<div class="card card-custom h-100 WidgetSupervisor-filter">
    <div class="card-header align-items-center border-0">
        <h3 class="card-title align-items-start flex-column">
            <span class="font-weight-bolder text-dark">
                {{l("WidgetPersonnelByDay")}}
            </span>
        </h3>
        <div>
            <i class="fas fa-id-card gray-color">
                <span class="legend">{{l("EnteredDate")}}</span>
            </i>
            <i class="fas fa-exclamation-circle red-color"><span class="legend">{{l("HoursAssignedLegend")}}</span></i>
            <i class="fas fa-check-circle green-color"><span class="legend">{{l("Approved")}}</span></i>
            <i class="fas fa-hourglass-half yellow-color">
                <span class="legend">{{l("Submitted")}}</span>
            </i>
        </div>

        <div class="card-toolbar">
            <button mat-icon-button [matMenuTriggerFor]="menu" class="btn">
                <mat-icon>download</mat-icon>
            </button>

            <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="exportData('pdf')" disabled>pdf</button>
                <button mat-menu-item (click)="exportData('csv')">csv</button>
                <button mat-menu-item (click)="exportData('xlsx')">xlsx</button>
            </mat-menu>
            <div class="mr-3 mb-3">
                <button class="btn btn-default" [ngClass]="{ 'btn-primary': personnelFilterIsActive, 'btn-inverted': !personnelFilterIsActive }" (click)="personnelSelector.open()">
                    {{ l("PersonnelFilter") }}
                </button>

                <div class="filter-button">
                    <mat-form-field>
                        <mat-select [formControl]="personnelFormCtrl" [multiple]="true" #personnelSelector>
                            <mat-option>
                                <ngx-mat-select-search noEntriesFoundLabel="No results found"
                                                       placeholderLabel="Find a personnel..." [formControl]="personnelFilterFormCtrl"
                                                       (input)="filterPersonnel()">
                                </ngx-mat-select-search>
                            </mat-option>
                            <mat-option *ngFor="let personnel of filteredPersonnel | async" [value]="personnel"
                                        (click)="refresh()" #option>
                                {{ personnel.firstName }} {{ personnel.lastName }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="mr-3 mb-3">
                <button class="btn btn-default" [ngClass]="{ 'btn-primary': nameFilterIsActive, 'btn-inverted': !nameFilterIsActive }" (click)="nameSelector.open()">
                    {{ l("Supervisor") }}
                </button>

                <div class="filter-button">
                    <mat-form-field>
                        <mat-select [formControl]="userNameFormCtrl" [multiple]="true" #nameSelector>
                            <mat-option>
                                <ngx-mat-select-search noEntriesFoundLabel="No results found"
                                                       placeholderLabel="Find a supervisor..." [formControl]="userNameFilterFormCtrl"
                                                       (input)="filterUserNames()">
                                </ngx-mat-select-search>
                            </mat-option>
                            <mat-option *ngFor="let name of  filteredName | async" [value]="name" (click)="refresh()"
                                        #option>
                                {{l(name.staffUser.userName)}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="mr-3 mb-3">
                <button class="btn btn-default btn-inverted" [ngClass]="{ 'btn-primary': statusFilterIsActive, 'btn-inverted': !statusFilterIsActive }" (click)="statusSelector.open()">
                    {{ l("Status") }}
                </button>
                <div class="filter-button">
                    <mat-form-field>
                        <mat-select [formControl]="statusFormCtrl" [multiple]="true" #statusSelector>
                            <mat-option>
                                <ngx-mat-select-search noEntriesFoundLabel="No results found"
                                    placeholderLabel="Find a status..." [formControl]="statusFilterFormCtrl"
                                    (input)="filterStatus()">
                                </ngx-mat-select-search>
                            </mat-option>
                            <mat-option *ngFor="let status of filteredStatus | async" [value]="status"
                                (click)="refresh()" #option>

                                {{l(status.name)}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
    <div class="report-sub-header-section">
        <div class="report-sub-header-week">
            <p>{{ l("SelectedWeek") }}: <span>{{startDate | date: "dd/MM/yy"}} - {{endDate | date: "dd/MM/yy"}}</span></p>
            <div class="report-filter" *ngIf="filterNameShow"><a (click)="clear()"><mat-icon>close</mat-icon></a><span>{{ filterNameShow }}</span></div>
        </div>
        <div class="report-sub-header-date">
            <div class="report-sub-header">
                <div class="report-sub-header-btn">
                    <button (click)="GetThisWeek()" mat-button class="report-sub-header-button">
                        <mat-icon>today</mat-icon>
                        <span>{{ l("Today") }}</span>
                    </button>
                </div>
                <div class="report-sub-header-navigate-before">
                    <mat-icon (click)="GetPrevWeek()">navigate_before</mat-icon>
                </div>
                <div class="report-sub-header-navigate-after">
                    <mat-icon (click)="GetNextWeek()">navigate_next</mat-icon>
                </div>
                <div class="report-sub-header-datepicker">
                    <mat-form-field>
                        <mat-label>{{ l("ChooseADate") }}</mat-label>
                        <input matInput [matDatepicker]="datepicker" (dateInput)="onDateSelected($event)">
                        <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
                        <mat-datepicker #datepicker></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
    <div class="card-bodyForStickyTable table-container">
        <p-table [value]="personnelHours" [columns]="cols" [paginator]="false" [lazy]="true" role="grid"
            class="detailContentTable">
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th>{{"Name"}}</th>
                    <th *ngFor="let col of columns" class="classAlignCenter">
                        <div class="report-date">{{col.header | date:'dd/MM/yy' }}</div>
                        <span class="report-day">{{col.header | date:'EEEE' }}</span>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-record>
                <tr class="height60">
                    <td class="allocationNameTd">
                        <ng-container>
                            <div class="font-weight-bolder text-dark">
                                {{record.firstName}} {{record.lastName}}
                            </div>

                            <div class="text-muted rolefield">
                                {{record.trade}}
                            </div>
                        </ng-container>
                    </td>

                    <td *ngFor="let p of record.daysDetails">
                        <div (click)="GetPersonnelAllocationDetails(p,record)" class="clickable">
                            <ng-container>

                                <div class="classAlignCenter">
                                    {{p.hoursCount != 0 ? p.hoursCount : ""}}

                                </div>

                            </ng-container>
                            <ng-container>
                                <div class="classAlignCenter" ng-if="p.hoursCount>0">

                                    <i *ngIf="p.hoursCount > 0" class="fas fa-id-card gray-color"
                                        title="{{startTimeMessage(p)}}"></i>
                                    <i *ngIf="p.multipleUser" class="fas fa-exclamation-circle red-color"></i>
                                    <i *ngIf="p.notAllApproved" class="fas fa-hourglass-half yellow-color"></i>
                                    <i *ngIf="p.allApproved" class="fas fa-check-circle green-color"></i>
                                </div>
                            </ng-container>
                        </div>
                    </td>

                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
